import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermission } from '@fs/zion-permissions'
import getProfileView from './getProfileView'
import useProfile from './useProfile'
import updateBirthDate, { toCisDate } from '../services/updateBirthDate'

export default function useProfileView() {
  const { profile, profileLoading, handleChangeProfile, updateLocalProfile } = useProfile()
  const [canSetPublic] = usePermission('DiscloseUserProfile', 'UserProfile')
  const { t } = useTranslation()
  const returnProps = useMemo(() => {
    const profileView = getProfileView({ profile, canSetPublic, t })
    // can remove this line once all components are using the new profileView
    profileView.profile = profile
    const handleChangeProfileView = (profileViewItem, formValues) => {
      const profileChange = profileViewItem.asProfileItem(formValues)
      return handleChangeProfile(profileChange)
    }
    const handleChangeBirthDate = async ({ day, month, year }) => {
      await updateBirthDate(toCisDate({ day, month, year }))
      const isoDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
      updateLocalProfile({ birthDate: { value: isoDate } })
    }
    return {
      profileView,
      profileViewLoading: profileLoading,
      handleChangeProfileView,
      handleChangeBirthDate,
    }
  }, [canSetPublic, profile, profileLoading, handleChangeProfile, updateLocalProfile, t])
  return returnProps
}
